// 국가
export const country = [
    {name:"안도라", name_en: "ANDORRA", code: "AD"},
    {name:"아랍에미리트", name_en: "UNITED ARAB EMIRATES", code: "AE"},
    {name:"아프가니스탄", name_en: "AFGHANISTAN", code: "AF"},
    {name:"안티구아 바부다", name_en: "ANTIGUA AND BARBUDA", code: "AG"},
    {name:"앙길라", name_en: "ANGUILLA", code: "AI"},
    {name:"알바니아", name_en: "ALBANIA", code: "AL"},
    {name:"아르메니아", name_en: "ARMENIA", code: "AM"},
    {name:"앙골라", name_en: "ANGOLA", code: "AO"},
    {name:"안타티카", name_en: "ANTARCTICA", code: "AQ"},

    {name:"아르헨티나", name_en: "ARGENTINA", code: "AR"},
    {name:"오스트리아", name_en: "AUSTRIA", code: "AT"},
    {name:"호주", name_en: "AUSTRALIA", code: "AU"},
    {name:"아루바", name_en: "ARUBA", code: "AW"},
    {name:"알랜드 군도", name_en: "ALAND ISLANDS", code: "AX"},
    {name:"아제르바이잔", name_en: "AZERBAIJAN", code: "AZ"},
    {name:"보스니아 헤르체고비나", name_en: "BOSNIA HERCEGOVINA", code: "BA"},
    {name:"바베이도스", name_en: "BARBADOS", code: "BB"},
    {name:"방글라데시", name_en: "BANGLADESH", code: "BD"},
    {name:"벨기에", name_en: "BELGIUM", code: "BE"},

    {name:"부르키나파소", name_en: "BURKINA FASO", code: "BF"},
    {name:"불가리아", name_en: "BULGARIA", code: "BG"},
    {name:"바레인", name_en: "BAHRAIN", code: "BH"},
    {name:"브룬디", name_en: "BURUNDI", code: "BI"},
    {name:"베냉", name_en: "BENIN", code: "BJ"},
    {name:"버뮤다", name_en: "BERMUDA", code: "BM"},
    {name:"브루나이", name_en: "BRUNEI DARUSSALAM", code: "BN"},
    {name:"볼리비아", name_en: "BOLIVIA", code: "BO"},
    {name:"보네르", name_en: "BONAIRE", code: "BQ"},
    {name:"브라질", name_en: "BRAZIL", code: "BR"},

    {name:"바하마", name_en: "BAHAMAS", code: "BS"},
    {name:"부탄", name_en: "BHUTAN", code: "BT"},
    {name:"보츠와나", name_en: "BOTSWANA", code: "BW"},
    {name:"벨라루스", name_en: "BELARUS", code: "BY"},
    {name:"벨리즈", name_en: "BELIZE", code: "BZ"},
    {name:"캐나다", name_en: "CANADA", code: "CA"},
    {name:"콩고민주공화국", name_en: "Democratic Republic of the Congo", code: "CD"},
    {name:"중앙아프리카공화국", name_en: "CENTRAL AFRICAN REPUBLIC", code: "CF"},
    {name:"콩고", name_en: "CONGO", code: "CG"},
    {name:"스위스", name_en: "SWITZERLAND", code: "CH"},

    {name:"코트디부아르", name_en: "COTE D`IVOIRE", code: "CI"},
    {name:"칠레", name_en: "CHILE", code: "CL"},
    {name:"카메룬", name_en: "CAMEROON", code: "CM"},
    {name:"중국", name_en: "CHINA", code: "CN"},
    {name:"콜롬비아", name_en: "COLOMBIA", code: "CO"},
    {name:"코스타리카", name_en: "COSTA RICA", code: "CR"},
    {name:"쿠바", name_en: "CUBA", code: "CU"},
    {name:"카보베르데", name_en: "CAPE VERDE", code: "CV"},
    {name:"큐라소", name_en: "CURACAO", code: "CW"},
    {name:"사이프러스", name_en: "CYPRUS", code: "CY"},

    {name:"체코공화국", name_en: "CZECH REPUBLIC", code: "CZ"},
    {name:"독일", name_en: "GERMANY", code: "DE"},
    {name:"지부티", name_en: "DJIBOUTI", code: "DJ"},
    {name:"덴마크", name_en: "DENMARK", code: "DK"},
    {name:"도미니카 연방", name_en: "DOMINICA", code: "DM"},
    {name:"도미니카 공화국", name_en: "DOMINICAN REPUBLIC", code: "DO"},
    {name:"알제리", name_en: "ALGERIA", code: "DZ"},
    {name:"에콰도르", name_en: "ECUADOR", code: "EC"},
    {name:"에스토니아", name_en: "ESTONIA", code: "EE"},
    {name:"이집트", name_en: "EGYPT", code: "EG"},

    {name:"서사하라", name_en: "WESTERN SAHARA", code: "EH"},
    {name:"에리트레아", name_en: "ERITREA", code: "ER"},
    {name:"스페인", name_en: "SPAIN", code: "ES"},
    {name:"에티오피아", name_en: "ETHIOPIA", code: "ET"},
    {name:"핀란드", name_en: "FINLAND", code: "FI"},
    {name:"피지", name_en: "FIJI", code: "FJ"},
    {name:"포클랜드섬", name_en: "FALKLAND ISLANDS", code: "FK"},
    {name:"미크로네시아", name_en: "MICRONESIA", code: "FM"},
    {name:"페로 군도", name_en: "FAROE ISLANDS", code: "FO"},
    {name:"프랑스", name_en: "FRANCE", code: "FR"},

    {name:"가봉", name_en: "GABON", code: "GA"},
    {name:"영국", name_en: "UNITED KINGDOM", code: "GB"},
    {name:"그레나다", name_en: "GRENADA", code: "GD"},
    {name:"조지아", name_en: "GEORGIA", code: "GE"},
    {name:"건지", name_en: "GUERNSEY", code: "GG"},
    {name:"가나", name_en: "GHANA", code: "GH"},
    {name:"지브랄타", name_en: "GIBRALTAR", code: "GI"},
    {name:"그린랜드", name_en: "GREENLAND", code: "GL"},
    {name:"감비아", name_en: "GAMBIA", code: "GM"},
    {name:"기니", name_en: "GUINEA", code: "GN"},

    {name:"과들루프", name_en: "GUADELOUPE", code: "GP"},
    {name:"적도 기니", name_en: "EQUATORIAL GUINEA", code: "GQ"},
    {name:"그리스", name_en: "GREECE", code: "GR"},
    {name:"과테말라", name_en: "GUATEMALA", code: "GT"},
    {name:"괌", name_en: "GUAM", code: "GU"},
    {name:"기네비쏘", name_en: "GUINEA-BISSAU", code: "GW"},
    {name:"가이아나", name_en: "GUYANA", code: "GY"},
    {name:"홍콩", name_en: "HONG KONG", code: "HK"},
    {name:"온두라스", name_en: "HONDURAS", code: "HN"},
    {name:"크로아티아", name_en: "CROATIA", code: "HR"},

    {name:"아이티", name_en: "HAITI", code: "HT"},
    {name:"헝가리", name_en: "HUNGARY", code: "HU"},
    {name:"인도네시아", name_en: "INDONESIA", code: "ID"},
    {name:"아일랜드", name_en: "IRELAND", code: "IE"},
    {name:"이스라엘", name_en: "ISRAEL", code: "IL"},
    {name:"맨섬", name_en: "ISLE OF MAN", code: "IM"},
    {name:"인도", name_en: "INDIA", code: "IN"},
    {name:"이라크", name_en: "IRAQ", code: "IQ"},
    {name:"이란", name_en: "IRAN", code: "IR"},
    {name:"아이슬란드", name_en: "ICELAND", code: "IS"},

    {name:"이탈리아", name_en: "ITALY", code: "IT"},
    {name:"저지", name_en: "JERSEY", code: "JE"},
    {name:"자메이카", name_en: "JAMAICA", code: "JM"},
    {name:"요르단", name_en: "JORDAN", code: "JO"},
    {name:"일본", name_en: "JAPAN", code: "JP"},
    {name:"케냐", name_en: "KENYA", code: "KE"},
    {name:"키르기즈스탄", name_en: "KYRGYZSTAN", code: "KG"},
    {name:"캄보디아", name_en: "CAMBODIA", code: "KH"},
    {name:"키리바시", name_en: "KIRIBATI", code: "KI"},
    {name:"코모르", name_en: "COMOROS", code: "KM"},

    {name:"북한", name_en: "NORTH KOREA", code: "KP"},
    {name:"대한민국", name_en: "SOUTH KOREA", code: "KR"},
    {name:"코소보", name_en: "KOSOVO", code: "XK"},
    {name:"쿠웨이트", name_en: "KUWAIT", code: "KW"},
    {name:"카자흐스탄", name_en: "KAZAKHSTAN", code: "KZ"},
    {name:"라오스", name_en: "LAOS", code: "LA"},
    {name:"레바논", name_en: "LEBANON", code: "LB"},
    {name:"리히텐슈타인", name_en: "LIECHTENSTEIN", code: "LI"},
    {name:"스리랑카", name_en: "SRI LANKA", code: "LK"},
    {name:"라이베리아", name_en: "LIBERIA", code: "LR"},

    {name:"레소토", name_en: "LESOTHO", code: "LS"},
    {name:"리투아니아", name_en: "LITHUANIA", code: "LT"},
    {name:"룩셈부르크", name_en: "LUXEMBOURG", code: "LU"},
    {name:"라트비아", name_en: "LATVIA", code: "LV"},
    {name:"리비아", name_en: "LIBYAN ARAB JAMAHIRIYA", code: "LY"},
    {name:"모로코", name_en: "MOROCCO", code: "MA"},
    {name:"모나코", name_en: "MONACO", code: "MC"},
    {name:"몰도바", name_en: "MOLDOVA", code: "MD"},
    {name:"마다가스카르", name_en: "MADAGASCAR", code: "MG"},
    {name:"마샬군도", name_en: "MARSHALL ISLANDS", code: "MH"},

    {name:"마케도니아", name_en: "MACEDONIA", code: "MK"},
    {name:"말리", name_en: "MALI", code: "ML"},
    {name:"미얀마", name_en: "MYANMAR", code: "MM"},
    {name:"몽골", name_en: "MONGOLIA", code: "MN"},
    {name:"마카오", name_en: "MACAU", code: "MO"},
    {name:"마르티니크", name_en: "MARTINIQUE", code: "MQ"},
    {name:"모리타니", name_en: "MAURITANIA", code: "MR"},
    {name:"몬트세라트", name_en: "MONTSERRAT", code: "MS"},
    {name:"몰타", name_en: "MALTA", code: "MT"},
    {name:"모리셔스", name_en: "MAURITIUS", code: "MU"},

    {name:"몰디브", name_en: "MALDIVES", code: "MV"},
    {name:"말라위", name_en: "MALAWI", code: "MW"},
    {name:"멕시코", name_en: "MEXICO", code: "MX"},
    {name:"말레이시아", name_en: "MALAYSIA", code: "MY"},
    {name:"모잠비크", name_en: "MOZAMBIQUE", code: "MZ"},
    {name:"나미비아", name_en: "NAMIBIA", code: "NA"},
    {name:"뉴칼레도니아", name_en: "NEW CALEDONIA", code: "NC"},
    {name:"니제르", name_en: "NIGER", code: "NE"},
    {name:"나이지리아", name_en: "NIGERIA", code: "NG"},
    {name:"니카라과", name_en: "NICARAGUA", code: "NI"},

    {name:"네덜란드", name_en: "NETHERLANDS", code: "NL"},
    {name:"노르웨이", name_en: "NORWAY", code: "NO"},
    {name:"네팔", name_en: "NEPAL", code: "NP"},
    {name:"나우루", name_en: "NAURU", code: "NR"},
    {name:"니우에", name_en: "NIUE", code: "NU"},
    {name:"뉴질랜드", name_en: "NEW ZEALAND", code: "NZ"},
    {name:"오만", name_en: "OMAN", code: "OM"},
    {name:"파나마", name_en: "PANAMA", code: "PA"},
    {name:"페루", name_en: "PERU", code: "PE"},
    {name:"파푸아뉴기니", name_en: "PAPUANEWGUINEA", code: "PG"},

    {name:"필리핀", name_en: "PHILIPPINES", code: "PH"},
    {name:"파키스탄", name_en: "PAKISTAN", code: "PK"},
    {name:"폴란드", name_en: "POLAND", code: "PL"},
    {name:"핏케언 군도", name_en: "PITCAIRN", code: "PN"},
    {name:"푸에르토리코", name_en: "PUERTO RICO", code: "PR"},
    {name:"팔레스타인", name_en: "PALESTINE", code: "PS"},
    {name:"포르투갈", name_en: "PORTUGAL", code: "PT"},
    {name:"팔라우", name_en: "PALAU", code: "PW"},
    {name:"파라과이", name_en: "PARAGUAY", code: "PY"},
    {name:"카타르", name_en: "QATAR", code: "QA"},

    {name:"리유니언", name_en: "REUNION", code: "RE"},
    {name:"루마니아", name_en: "ROMANIA", code: "RO"},
    {name:"세르비아", name_en: "SERBIA", code: "RS"},
    {name:"러시아", name_en: "RUSSIAN FEDERATION", code: "RU"},
    {name:"르완다", name_en: "RWANDA", code: "RW"},
    {name:"사우디아라비아", name_en: "SAUDI ARABIA", code: "SA"},
    {name:"솔로몬 군도", name_en: "SOLOMON ISLANDS", code: "SB"},
    {name:"이셸", name_en: "SEYCHELLES", code: "SC"},
    {name:"수단", name_en: "SUDAN", code: "SD"},
    {name:"스웨덴", name_en: "SWEDEN", code: "SE"},

    {name:"싱가포르", name_en: "SINGAPORE", code: "SG"},
    {name:"세인트 헬레나", name_en: "SAINT HELENA", code: "SH"},
    {name:"슬로베니아", name_en: "SLOVENIA", code: "SI"},
    {name:"슬로바키아", name_en: "SLOVAKIA", code: "SK"},
    {name:"시에라리온", name_en: "SIERRA LEONE", code: "SL"},
    {name:"산마리노", name_en: "SAN MARINO", code: "SM"},
    {name:"세네갈", name_en: "SENEGAL", code: "SN"},
    {name:"소말리아", name_en: "SOMALIA", code: "SO"},
    {name:"수리남", name_en: "SURINAME", code: "SR"},
    {name:"남수단", name_en: "SOUTH SUDAN", code: "SS"},

    {name:"엘살바도르", name_en: "EL SALVADOR", code: "SV"},
    {name:"시리아", name_en: "SYRIAN ARAB REPUBLIC", code: "SY"},
    {name:"스와질랜드", name_en: "SWAZILAND", code: "SZ"},
    {name:"차드", name_en: "CHAD", code: "TD"},
    {name:"토고", name_en: "TOGO", code: "TG"},
    {name:"태국", name_en: "THAILAND", code: "TH"},
    {name:"타지키스탄", name_en: "TAJIKISTAN", code: "TJ"},
    {name:"토켈라우", name_en: "TOKELAU", code: "TK"},
    {name:"동티모르", name_en: "EAST TIMOR", code: "TL"},
    {name:"투르크메니스탄", name_en: "TURKMENISTAN", code: "TM"},

    {name:"튀니지", name_en: "TUNISIA", code: "TN"},
    {name:"통가", name_en: "TONGA", code: "TO"},
    {name:"터키", name_en: "TURKEY", code: "TR"},
    {name:"트리니다드토바고", name_en: "TRINIDAD AND TOBAGO", code: "TT"},
    {name:"투발루", name_en: "TUVALU", code: "TV"},
    {name:"대만", name_en: "TAIWAN", code: "TW"},
    {name:"탄자니아", name_en: "TANZANIA", code: "TZ"},
    {name:"우크라이나", name_en: "UKRAINE", code: "UA"},
    {name:"우간다", name_en: "UGANDA", code: "UG"},
    {name:"미국", name_en: "UNITED STATES", code: "US"},

    {name:"우루과이", name_en: "URUGUAY", code: "UY"},
    {name:"우즈베키스탄", name_en: "UZBEKISTAN", code: "UZ"},
    {name:"바티칸", name_en: "VATICAN CITY STATE", code: "VA"},
    {name:"세인트 빈센트 그레나딘스", name_en: "SAINT VINCENT AND THE GRENADINES", code: "VC"},
    {name:"베네수엘라", name_en: "VENEZUELA", code: "VE"},
    {name:"베트남", name_en: "VIET NAM", code: "VN"},
    {name:"바누아투", name_en: "VANUATU", code: "VU"},
    {name:"사모아", name_en: "SAMOA", code: "WS"},
    {name:"예멘", name_en: "YEMEN", code: "YE"},
    {name:"마요트", name_en: "MAYOTTE", code: "YT"},

    {name:"유고슬라비아", name_en: "YUGOSLAVIA", code: "YU"},
    {name:"남아프리카공화국", name_en: "SOUTH AFRICA", code: "ZA"},
    {name:"잠비아", name_en: "ZAMBIA", code: "ZM"},
    {name:"자이르", name_en: "ZAIRE", code: "ZR"},
    {name:"짐바브웨", name_en: "ZIMBABWE", code: "ZW"},
    {name:"국적불명", name_en: "UNKNOWN", code: "ZZ"},
]

export const dialing = [
    {name:"안도라", name_en: "ANDORRA", code: "+376"},
    {name:"아랍에미리트", name_en: "UNITED ARAB EMIRATES", code: "+971"},
    {name:"아프가니스탄", name_en: "AFGHANISTAN", code: "+93"},
    {name:"안티구아 바부다", name_en: "ANTIGUA AND BARBUDA", code: "+1 268"},
    {name:"앙길라", name_en: "ANGUILLA", code: "+1 264"},
    {name:"알바니아", name_en: "ALBANIA", code: "+355"},
    {name:"아르메니아", name_en: "ARMENIA", code: "+374"},
    {name:"앙골라", name_en: "ANGOLA", code: "+244"},
    {name:"안타티카", name_en: "ANTARCTICA", code: "+672"},
    {name:"아르헨티나", name_en: "ARGENTINA", code: "+54"},

    {name:"오스트리아", name_en: "AUSTRIA", code: "+43"},
    {name:"호주", name_en: "AUSTRALIA", code: "+61"},
    {name:"아루바", name_en: "ARUBA", code: "+297"},
    {name:"알랜드 군도", name_en: "ALAND ISLANDS", code: "+358 18"},
    {name:"아제르바이잔", name_en: "AZERBAIJAN", code: "+994"},
    {name:"보스니아 헤르체고비나", name_en: "BOSNIA HERCEGOVINA", code: "+387"},
    {name:"바베이도스", name_en: "BARBADOS", code: "+1 246"},
    {name:"방글라데시", name_en: "BANGLADESH", code: "+880"},
    {name:"벨기에", name_en: "BELGIUM", code: "+32"},
    {name:"부르키나파소", name_en: "BURKINA FASO", code: "+226"},

    {name:"불가리아", name_en: "BULGARIA", code: "+359"},
    {name:"바레인", name_en: "BAHRAIN", code: "+973"},
    {name:"브룬디", name_en: "BURUNDI", code: "+257"},
    {name:"베냉", name_en: "BENIN", code: "+229"},
    {name:"버뮤다", name_en: "BERMUDA", code: "+1 441"},
    {name:"브루나이", name_en: "BRUNEI DARUSSALAM", code: "+673"},
    {name:"볼리비아", name_en: "BOLIVIA", code: "+591"},
    {name:"보네르", name_en: "BONAIRE", code: "+599 7"},
    {name:"브라질", name_en: "BRAZIL", code: "+55"},
    {name:"바하마", name_en: "BAHAMAS", code: "+1 242"},

    {name:"부탄", name_en: "BHUTAN", code: "+975"},
    {name:"보츠와나", name_en: "BOTSWANA", code: "+267"},
    {name:"벨라루스", name_en: "BELARUS", code: "+375"},
    {name:"벨리즈", name_en: "BELIZE", code: "+501"},
    {name:"캐나다", name_en: "CANADA", code: "+1"},
    {name:"콩고민주공화국", name_en: "Democratic Republic of the Congo", code: "+243"},
    {name:"중앙아프리카공화국", name_en: "CENTRAL AFRICAN REPUBLIC", code: "+236"},
    {name:"콩고", name_en: "CONGO", code: "+242"},
    {name:"스위스", name_en: "SWITZERLAND", code: "+41"},
    {name:"코트디부아르", name_en: "COTE D`IVOIRE", code: "+225"},

    {name:"칠레", name_en: "CHILE", code: "+56"},
    {name:"카메룬", name_en: "CAMEROON", code: "+237"},
    {name:"중국", name_en: "CHINA", code: "+86"},
    {name:"콜롬비아", name_en: "COLOMBIA", code: "+57"},
    {name:"코스타리카", name_en: "COSTA RICA", code: "+506"},
    {name:"쿠바", name_en: "CUBA", code: "+53"},
    {name:"카보베르데", name_en: "CAPE VERDE", code: "+238"},
    {name:"큐라소", name_en: "CURACAO", code: "+599 9"},
    {name:"사이프러스", name_en: "CYPRUS", code: "+357"},
    {name:"체코공화국", name_en: "CZECH REPUBLIC", code: "+420"},

    {name:"독일", name_en: "GERMANY", code: "+49"},
    {name:"지부티", name_en: "DJIBOUTI", code: "+253"},
    {name:"덴마크", name_en: "DENMARK", code: "+45"},
    {name:"도미니카 연방", name_en: "DOMINICA", code: "+1 767"},
    {name:"도미니카 공화국", name_en: "DOMINICAN REPUBLIC", code: "+1 809"},
    {name:"알제리", name_en: "ALGERIA", code: "+1 213"},
    {name:"에콰도르", name_en: "ECUADOR", code: "+593"},
    {name:"에스토니아", name_en: "ESTONIA", code: "+372"},
    {name:"이집트", name_en: "EGYPT", code: "+20"},
    {name:"서사하라", name_en: "WESTERN SAHARA", code: "+212"},

    {name:"에리트레아", name_en: "ERITREA", code: "+291"},
    {name:"스페인", name_en: "SPAIN", code: "+34"},
    {name:"에티오피아", name_en: "ETHIOPIA", code: "+251"},
    {name:"핀란드", name_en: "FINLAND", code: "+358"},
    {name:"피지", name_en: "FIJI", code: "+679"},
    {name:"포클랜드섬", name_en: "FALKLAND ISLANDS", code: "+500"},
    {name:"미크로네시아", name_en: "MICRONESIA", code: "+691"},
    {name:"페로 군도", name_en: "FAROE ISLANDS", code: "+298"},
    {name:"프랑스", name_en: "FRANCE", code: "+33"},
    {name:"가봉", name_en: "GABON", code: "+241"},

    {name:"영국", name_en: "UNITED KINGDOM", code: "+44"},
    {name:"그레나다", name_en: "GRENADA", code: "+1 473"},
    {name:"조지아", name_en: "GEORGIA", code: "+995"},
    {name:"건지", name_en: "GUERNSEY", code: "+44 1481"},
    {name:"가나", name_en: "GHANA", code: "+233"},
    {name:"지브랄타", name_en: "GIBRALTAR", code: "+350"},
    {name:"그린랜드", name_en: "GREENLAND", code: "+299"},
    {name:"감비아", name_en: "GAMBIA", code: "+220"},
    {name:"기니", name_en: "GUINEA", code: "+218"},
    {name:"과들루프", name_en: "GUADELOUPE", code: "+590"},

    {name:"적도 기니", name_en: "EQUATORIAL GUINEA", code: "+240"},
    {name:"그리스", name_en: "GREECE", code: "+30"},
    {name:"과테말라", name_en: "GUATEMALA", code: "+502"},
    {name:"괌", name_en: "GUAM", code: "+1 671"},
    {name:"기네비쏘", name_en: "GUINEA-BISSAU", code: "+245"},
    {name:"가이아나", name_en: "GUYANA", code: "+592"},
    {name:"홍콩", name_en: "HONG KONG", code: "+852"},
    {name:"온두라스", name_en: "HONDURAS", code: "+504"},
    {name:"크로아티아", name_en: "CROATIA", code: "+385"},
    {name:"아이티", name_en: "HAITI", code: "+509"},

    {name:"헝가리", name_en: "HUNGARY", code: "+36"},
    {name:"인도네시아", name_en: "INDONESIA", code: "+62"},
    {name:"아일랜드", name_en: "IRELAND", code: "+353"},
    {name:"이스라엘", name_en: "ISRAEL", code: "+972"},
    {name:"맨섬", name_en: "ISLE OF MAN", code: "+421"},
    {name:"인도", name_en: "INDIA", code: "+91"},
    {name:"이라크", name_en: "IRAQ", code: "+964"},
    {name:"이란", name_en: "IRAN", code: "+98"},
    {name:"아이슬란드", name_en: "ICELAND", code: "+354"},
    {name:"이탈리아", name_en: "ITALY", code: "+39"},

    {name:"저지", name_en: "JERSEY", code: "+44 1534"},
    {name:"자메이카", name_en: "JAMAICA", code: "+1 876"},
    {name:"요르단", name_en: "JORDAN", code: "+962"},
    {name:"일본", name_en: "JAPAN", code: "+81"},
    {name:"케냐", name_en: "KENYA", code: "+254"},
    {name:"키르기즈스탄", name_en: "KYRGYZSTAN", code: "+996"},
    {name:"캄보디아", name_en: "CAMBODIA", code: "+855"},
    {name:"키리바시", name_en: "KIRIBATI", code: "+686"},
    {name:"코모르", name_en: "COMOROS", code: "+269"},
    {name:"북한", name_en: "NORTH KOREA", code: "+850"},

    {name:"대한민국", name_en: "SOUTH KOREA", code: "+82"},
    {name:"코소보", name_en: "KOSOVO", code: "+383"},
    {name:"쿠웨이트", name_en: "KUWAIT", code: "+965"},
    {name:"카자흐스탄", name_en: "KAZAKHSTAN", code: "+7"},
    {name:"라오스", name_en: "LAOS", code: "+856"},
    {name:"레바논", name_en: "LEBANON", code: "+961"},
    {name:"리히텐슈타인", name_en: "LIECHTENSTEIN", code: "+423"},
    {name:"스리랑카", name_en: "SRI LANKA", code: "+94"},
    {name:"라이베리아", name_en: "LIBERIA", code: "+231"},
    {name:"레소토", name_en: "LESOTHO", code: "+266"},

    {name:"리투아니아", name_en: "LITHUANIA", code: "+370"},
    {name:"룩셈부르크", name_en: "LUXEMBOURG", code: "+352"},
    {name:"라트비아", name_en: "LATVIA", code: "+371"},
    {name:"리비아", name_en: "LIBYAN ARAB JAMAHIRIYA", code: "+218"},
    {name:"모로코", name_en: "MOROCCO", code: "+212"},
    {name:"모나코", name_en: "MONACO", code: "+377"},
    {name:"몰도바", name_en: "MOLDOVA", code: "+373"},
    {name:"마다가스카르", name_en: "MADAGASCAR", code: "+261"},
    {name:"마샬군도", name_en: "MARSHALL ISLANDS", code: "+692"},
    {name:"마케도니아", name_en: "MACEDONIA", code: "+389"},

    {name:"말리", name_en: "MALI", code: "+223"},
    {name:"미얀마", name_en: "MYANMAR", code: "+95"},
    {name:"몽골", name_en: "MONGOLIA", code: "+976"},
    {name:"마카오", name_en: "MACAU", code: "+853"},
    {name:"마르티니크", name_en: "MARTINIQUE", code: "+596"},
    {name:"모리타니", name_en: "MAURITANIA", code: "+222"},
    {name:"몬트세라트", name_en: "MONTSERRAT", code: "+1 664"},
    {name:"몰타", name_en: "MALTA", code: "+356"},
    {name:"모리셔스", name_en: "MAURITIUS", code: "+230"},

    {name:"몰디브", name_en: "MALDIVES", code: "+960"},
    {name:"말라위", name_en: "MALAWI", code: "+265"},
    {name:"멕시코", name_en: "MEXICO", code: "+52"},
    {name:"말레이시아", name_en: "MALAYSIA", code: "+60"},
    {name:"모잠비크", name_en: "MOZAMBIQUE", code: "+258"},
    {name:"나미비아", name_en: "NAMIBIA", code: "+264"},
    {name:"뉴칼레도니아", name_en: "NEW CALEDONIA", code: "+687"},
    {name:"니제르", name_en: "NIGER", code: "+227"},
    {name:"나이지리아", name_en: "NIGERIA", code: "+234"},
    {name:"니카라과", name_en: "NICARAGUA", code: "+505"},

    {name:"네덜란드", name_en: "NETHERLANDS", code: "+31"},
    {name:"노르웨이", name_en: "NORWAY", code: "+47"},
    {name:"네팔", name_en: "NEPAL", code: "+977"},
    {name:"나우루", name_en: "NAURU", code: "+674"},
    {name:"니우에", name_en: "NIUE", code: "+683"},
    {name:"뉴질랜드", name_en: "NEW ZEALAND", code: "+64"},
    {name:"오만", name_en: "OMAN", code: "+968"},
    {name:"파나마", name_en: "PANAMA", code: "+507"},
    {name:"페루", name_en: "PERU", code: "+51"},
    {name:"파푸아뉴기니", name_en: "PAPUANEWGUINEA", code: "+675"},

    {name:"필리핀", name_en: "PHILIPPINES", code: "+63"},
    {name:"파키스탄", name_en: "PAKISTAN", code: "+92"},
    {name:"폴란드", name_en: "POLAND", code: "+44 1534"},
    {name:"핏케언 군도", name_en: "PITCAIRN", code: "+64"},
    {name:"푸에르토리코", name_en: "PUERTO RICO", code: "+1 787"},
    {name:"팔레스타인", name_en: "PALESTINE", code: "+970"},
    {name:"포르투갈", name_en: "PORTUGAL", code: "+351"},
    {name:"팔라우", name_en: "PALAU", code: "+680"},
    {name:"파라과이", name_en: "PARAGUAY", code: "+595"},
    {name:"카타르", name_en: "QATAR", code: "+974"},

    {name:"리유니언", name_en: "REUNION", code: "+262"},
    {name:"루마니아", name_en: "ROMANIA", code: "+40"},
    {name:"세르비아", name_en: "SERBIA", code: "+381"},
    {name:"러시아", name_en: "RUSSIAN FEDERATION", code: "+7"},
    {name:"르완다", name_en: "RWANDA", code: "+250"},
    {name:"사우디아라비아", name_en: "SAUDI ARABIA", code: "+966"},
    {name:"솔로몬 군도", name_en: "SOLOMON ISLANDS", code: "+677"},
    {name:"이셸", name_en: "SEYCHELLES", code: "+248"},
    {name:"수단", name_en: "SUDAN", code: "+249"},
    {name:"스웨덴", name_en: "SWEDEN", code: "+46"},

    {name:"싱가포르", name_en: "SINGAPORE", code: "+65"},
    {name:"세인트 헬레나", name_en: "SAINT HELENA", code: "+290"},
    {name:"슬로베니아", name_en: "SLOVENIA", code: "+386"},
    {name:"슬로바키아", name_en: "SLOVAKIA", code: "+421"},
    {name:"시에라리온", name_en: "SIERRA LEONE", code: "+232"},
    {name:"산마리노", name_en: "SAN MARINO", code: "+378"},
    {name:"세네갈", name_en: "SENEGAL", code: "+221"},
    {name:"소말리아", name_en: "SOMALIA", code: "+252"},
    {name:"수리남", name_en: "SURINAME", code: "+597"},
    {name:"남수단", name_en: "SOUTH SUDAN", code: "+211"},

    {name:"엘살바도르", name_en: "EL SALVADOR", code: "+503"},
    {name:"시리아", name_en: "SYRIAN ARAB REPUBLIC", code: "+963"},
    {name:"스와질랜드", name_en: "SWAZILAND", code: "+268"},
    {name:"차드", name_en: "CHAD", code: "+235"},
    {name:"토고", name_en: "TOGO", code: "+228"},
    {name:"태국", name_en: "THAILAND", code: "+66"},
    {name:"타지키스탄", name_en: "TAJIKISTAN", code: "+992"},
    {name:"토켈라우", name_en: "TOKELAU", code: "+690"},
    {name:"동티모르", name_en: "EAST TIMOR", code: "+670"},
    {name:"투르크메니스탄", name_en: "TURKMENISTAN", code: "+993"},

    {name:"튀니지", name_en: "TUNISIA", code: "+1 216"},
    {name:"통가", name_en: "TONGA", code: "+676"},
    {name:"터키", name_en: "TURKEY", code: "+90"},
    {name:"트리니다드토바고", name_en: "TRINIDAD AND TOBAGO", code: "+868"},
    {name:"투발루", name_en: "TUVALU", code: "+688"},
    {name:"대만", name_en: "TAIWAN", code: "+886"},
    {name:"탄자니아", name_en: "TANZANIA", code: "+255"},
    {name:"우크라이나", name_en: "UKRAINE", code: "+380"},
    {name:"우간다", name_en: "UGANDA", code: "+256"},
    {name:"미국", name_en: "UNITED STATES", code: "+1"},

    {name:"우루과이", name_en: "URUGUAY", code: "+598"},
    {name:"우즈베키스탄", name_en: "UZBEKISTAN", code: "+998"},
    {name:"바티칸", name_en: "VATICAN CITY STATE", code: "+379"},
    {name:"세인트 빈센트 그레나딘스", name_en: "SAINT VINCENT AND THE GRENADINES", code: "+1 784"},
    {name:"베네수엘라", name_en: "VENEZUELA", code: "+52"},
    {name:"베트남", name_en: "VIET NAM", code: "+84"},
    {name:"바누아투", name_en: "VANUATU", code: "+678"},
    {name:"사모아", name_en: "SAMOA", code: "+685"},
    {name:"예멘", name_en: "YEMEN", code: "+967"},
    {name:"마요트", name_en: "MAYOTTE", code: "+269"},

    {name:"유고슬라비아", name_en: "YUGOSLAVIA", code: "+38"},
    {name:"남아프리카공화국", name_en: "SOUTH AFRICA", code: "+27"},
    {name:"잠비아", name_en: "ZAMBIA", code: "+260"},
    {name:"자이르", name_en: "ZAIRE", code: "+243"},
    {name:"짐바브웨", name_en: "ZIMBABWE", code: "+263"},
    {name:"국적불명", name_en: "UNKNOWN", code: ""}
]

// 은행
export const bank = [
    {name: "KEB하나은행 081", code: "081"},
    {name: "경남은행 039", code: "039"},
    {name: "광주은행 034", code: "034"},
    {name: "국민은행 004", code: "004"},
    {name: "기업은행 003", code: "003"},

    {name: "농협은행 011", code: "011"},
    {name: "대구은행 031", code: "031"},
    {name: "도이치은행 055", code: "055"},
    {name: "부산은행 032", code: "032"},
    {name: "산업은행 002", code: "002"},

    {name: "저축은행 050", code: "050"},
    {name: "새마을금고중앙회 045", code: "045"},
    {name: "신협 048", code: "048"},
    {name: "신한은행 088", code: "088"},
    {name: "우리은행 020", code: "020"},

    {name: "우체국 071", code: "071"},
    {name: "전북은행 037", code: "037"},
    {name: "제주은행 035", code: "035"},
    {name: "카카오뱅크 090", code: "090"},
    {name: "케이뱅크 089", code: "089"},

    {name: "한국씨티은행 027", code: "027"},
    {name: "BOA 060", code: "060"},
    {name: "HSBC 054", code: "054"},
    {name: "제이피모건체이스은행 057", code: "057"},
    {name: "SC제일은행 023", code: "023"},

    {name: "산림조합중앙회 064", code: "064"},
    {name: "중국공상은행 062", code: "062"},
    {name: "중국은행 063", code: "063"},
    {name: "중국건설은행 067", code: "067"},
    {name: "비엔피파리바은행 061", code: "061"},

    {name: "하나금융투자 270", code: "270"},
    {name: "교보증권 261", code: "261"},
    {name: "대신증권 267", code: "067"},
    {name: "미래에셋대우 238", code: "238"},
    {name: "DB금융투자 279", code: "279"},

    {name: "유안타증권 209", code: "209"},
    {name: "메리츠종합금융증권 287", code: "287"},
    {name: "부국증권 290", code: "290"},
    {name: "삼성증권 240", code: "240"},
    {name: "신영증권 291", code: "291"},

    {name: "신한금융투자 278", code: "278"},
    {name: "NH투자증권 247", code: "247"},
    {name: "유진투자증권 280", code: "280"},
    {name: "키움증권 264", code: "264"},
    {name: "하이투자증권 262", code: "262"},

    {name: "한국투자증권 243", code: "243"},
    {name: "한화투자증권 269", code: "269"},
    {name: "KB증권 218", code: "218"},
    {name: "이베스트투자증권 265", code: "265"},
    {name: "현대차투자증권 263", code: "263"},

    {name: "케이프투자증권 292", code: "292"},
    {name: "SK증권 266", code: "266"},
    {name: "한국포스증권 294", code: "294"},
    {name: "케이티비투자증권 227", code: "227"},
    {name: "BNK투자증권 224", code: "224"},

    {name: "바로투자증권 288", code: "288"},
]

export const permissionOption = {
    default : {
        label : '기본 설정',
        list :['userView','userEdit','userDownload']
             
    }
}